import { useEffect } from 'react';
import { apiValidateToken, handleLogout, getToken } from '../../api';

const TokenValidator = () => {
  useEffect(() => {
    const validateToken = async () => {
      const token = getToken();
      
      // Only validate if user has a token
      if (!token) {
        return;
      }

      try {
        const response = await apiValidateToken();
        
        if (!response.success || !response.valid) {
          console.log('Token invalid, logging out...');
          handleLogout();
        }
      } catch (error) {
        // Token validation failed (likely 401), handleLogout already called by fetchWithAuth
        console.log('Token validation error:', error.message);
      }
    };

    // Validate token on mount
    validateToken();

    // Revalidate token every 5 minutes
    const interval = setInterval(validateToken, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return null; // This component doesn't render anything
};

export default TokenValidator;
